import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tfDynamicRenderer]'
})
export class DynamicRendererDirective {
    constructor(
        public viewContainerRef: ViewContainerRef
    ) { }
}
